// extracted by mini-css-extract-plugin
export var category = "index-module--category--7af44";
export var date = "index-module--date--125dc";
export var date_category = "index-module--date_category--825e7";
export var recent_blogs = "index-module--recent_blogs--87108";
export var single_blog = "index-module--single_blog--e1203";